/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { NumberInput, Label, Input } from "@revvsales/components";

import { DateSelect, ReactSelect } from "../../../commonComponents";

// Actions Import
import PricebooksActions from "../../../actions/PricebooksActions";
// Internal Imports
import { GlobalUtils, ProgramUtils } from "../../../utils";
import { GRID, PRICEBOOK } from "../../../constants";

// Destructuring
const { twoArrayLookUp } = GlobalUtils;
const { sortArrayAccToMap } = ProgramUtils;
const { updateFormRowData, updateFormRowDataField } = PricebooksActions;
const { PRICING_METHODS, RECURRENCE: REC_PRD_OPTIONS } = GRID;
const { QUANTITY_UOM_BLANK_OPTION } = PRICEBOOK;

class FormField extends Component {
  state = {};

  _findCurrentProduct = (fld, isEdit) => {
    const productID = this.props.formRowData[fld];
    const product = twoArrayLookUp(
      this.props.products,
      this.props.unusedProducts,
      productID,
    );
    if (isEdit) {
      return product ? product.name : {};
    }
    return product ? product.name : "";
  };

  _changeProduct = (fld, value) => {
    const selectedProduct = twoArrayLookUp(
      this.props.unusedProducts,
      this.props.products,
      value.id,
    );
    this.props.updateFormRowDataField(fld, selectedProduct.id);
  };

  _changeClauses = (fld, value) => {
    this.props.updateFormRowDataField(fld, value);
  };

  _returnDefaultValues = type => {
    if (type === "dateColumn") {
      return moment();
    }
    if (this.props.defaultVal) {
      return this.props.defaultVal;
    }
    if (type === "text") {
      return "";
    }
    if (type === "singleSelect") {
      return {};
    }
    if (type === "numberColumn" && this.props.name === "max_usage") {
      return 0;
    }
  };

  // this is for finding current values in case of update
  _findCurrentValue = () => {
    const key = Object.keys(this.props.formRowData).find(
      item => item === this.props.fld,
    );
    let currentValue = this.props.formRowData[key];

    // Rewrite - remove this
    if (currentValue === "" && this.props.name === "max_usage_uom") {
      return "Unit";
    }
    // because false is a valid value
    if (
      currentValue === undefined ||
      currentValue === null ||
      currentValue === QUANTITY_UOM_BLANK_OPTION
    ) {
      return this._returnDefaultValues(this.props.type);
    }

    // This is to handle react select values but not arrays which will come in case of clauses which is a multiselect
    if (
      currentValue &&
      !Array.isArray(currentValue) &&
      typeof currentValue === "object"
    ) {
      return currentValue.value;
    }

    // This is to handle react select - multiselect eg - clauses
    if (this.props.name === "clauses" && Array.isArray(currentValue)) {
      currentValue = currentValue.map(clauseID => {
        const clauseObj = this.props.clauses.find(
          item => item.id === clauseID.id,
        );
        if (clauseObj) {
          return clauseObj;
        }
      });
      return currentValue;
    }
    return currentValue;
  };

  _findDummyValue = name => this.props.formDummyFields[name];

  _generateOptions = () => {
    const { formRowData, fieldMapIndex } = this.props;
    if (this.props.props[this.props.name]) {
      // Rewrite below code in a generic way
      // this.props.formRowData[fieldMapIndex.charge_type] === "Usage Based"

      // options for "uom" if product has a value
      if (formRowData[fieldMapIndex.product] && this.props.name === "uom") {
        // const selectedProduct = this.props.products.find(
        //   item => item.id === formRowData[fieldMapIndex.product],
        // );
        const selectedProduct = twoArrayLookUp(
          this.props.products,
          this.props.unusedProducts,
          formRowData[fieldMapIndex.product],
        );
        if (
          selectedProduct.type !== "Resource" &&
          selectedProduct.type !== "On shore resource" &&
          selectedProduct.type !== "Off shore resource"
        ) {
          return this.props.props.uom.filter(item => item !== "Person-Month");
        }
      }

      // options for "recurring_period" if charge_frequency has a value
      if (
        formRowData[fieldMapIndex.charge_frequency] &&
        this.props.name === "recurring_period"
      ) {
        const options = this.props.props.recurring_period.filter(item => {
          if (
            REC_PRD_OPTIONS[formRowData[fieldMapIndex.charge_frequency]] <=
            REC_PRD_OPTIONS[item]
          ) {
            return item;
          }
        });
        return sortArrayAccToMap(options, REC_PRD_OPTIONS);
      }

      // options for "quantity_uom"
      if (this.props.name === "quantity_uom" && !this.props.required) {
        return [
          QUANTITY_UOM_BLANK_OPTION,
          ...this.props.props[this.props.name],
        ];
      }

      // final options return if one of the below fields
      if (
        ["charge_frequency", "billing_frequency", "recurring_period"].includes(
          this.props.name,
        )
      ) {
        return sortArrayAccToMap(
          this.props.props[this.props.name],
          REC_PRD_OPTIONS,
        );
      }
      // final options return
      return this.props.props[this.props.name];
    }

    const customCol = this.props.customColumnDefs.find(
      item => item.fld === this.props.fld,
    );
    if (customCol && customCol.props) {
      return customCol.props.values;
    }
  };

  _updateNumberField = (fld, value) => {
    this.props.updateFormRowDataField(fld, value);
  };

  _updateObjField = (fld, value) => {
    const payload = {
      type: PRICING_METHODS.FLAT_PRICE,
      value,
    };
    this.props.updateFormRowDataField(fld, payload);
  };

  _setDate = date => {
    this.props.updateFormRowDataField(this.props.fld, moment(date).format());
  };

  _onCheckChange = val => {
    this.props.updateFormRowDataField(this.props.fld, val);
  };

  _updateSelectField = (fld, value) => {
    const selectedValue = value === QUANTITY_UOM_BLANK_OPTION ? "" : value;
    this.props.updateFormRowDataField(fld, selectedValue);
  };

  _onFocusOut = (event, fld, name) => {
    if (name === "selling_term" && event.target.value === "") {
      this.props.updateFormRowDataField(fld, 1);
    }
  };

  _generateField = type => {
    const {
      clauses,
      currencySymbol = "$",
      disabled,
      dummyField,
      fld,
      isCurrency,
      isEdit,
      label,
      multiSelect,
      name,
      placeHolder,
    } = this.props;
    switch (type) {
      case "text":
        if (dummyField) {
          return (
            <Input
              placeholder={`${placeHolder || label}`}
              value={this._findDummyValue(name)}
              disabled={disabled}
              id={name}
            />
          );
        }
        return (
          <Input
            placeholder={`${placeHolder || `Enter ${label}`}`}
            onChange={e =>
              this.props.updateFormRowDataField(fld, e.target.value)
            }
            value={this._findCurrentValue()}
            disabled={disabled}
            id={name}
            data-test="formfield-text-input"
          />
        );
      case "numberColumn":
        return (
          <NumberInput
            onBlur={event => this._onFocusOut(event, fld, name)}
            className={`${disabled ? "is-disabled" : ""}`}
            disabled={disabled}
            inpCurrencySymbol={currencySymbol}
            isCurrency={isCurrency}
            isFloat={isCurrency}
            onChange={value => this._updateNumberField(fld, value)}
            placeholder={`${placeHolder || `Enter ${label}`}`}
            value={this._findCurrentValue()}
            id={name}
            data-test="formfield-number-input"
          />
        );

      case "priceMatrixColumn":
        return (
          <NumberInput
            className={`${disabled ? "is-disabled" : ""}`}
            disabled={disabled}
            inpCurrencySymbol={currencySymbol}
            isCurrency={isCurrency}
            isFloat
            onChange={value => this._updateObjField(fld, value)}
            placeholder={`${placeHolder || `Enter ${label}`}`}
            value={this._findCurrentValue()}
            id={name}
            data-test="formfield-pricematrixcolumn-input"
          />
        );
      case "dateColumn":
        return (
          <DateSelect
            passDefaultDate
            selectedDate={this._findCurrentValue()}
            returnValue={date => this._setDate(date)}
            id={name}
          />
        );

      case "checkbox":
        return (
          <Label htmlFor={`checkbox-${name}`}>
            <Input
              id={`checkbox-${name}`}
              type="checkbox"
              value=""
              checked={this._findCurrentValue()}
              name={`checkbox-${name}`}
              onChange={value => this._onCheckChange(value.target.checked)}
              disabled={disabled}
              data-test="formfield-checkbox-input"
            />
            <span className="addproduct-checkbox-value">{label}</span>
            {this.props.required ? (
              <span className="required-input">*</span>
            ) : (
              ""
            )}
          </Label>
        );
      case "singleSelect":
        if (name === "product" && !isEdit) {
          return (
            <ReactSelect
              autoFocus
              isSearchable
              onChange={value => this._changeProduct(fld, value)}
              isDisabled={disabled}
              options={this.props.unusedProducts}
              value={this._findCurrentProduct(fld, isEdit)}
              valueKey="name"
              multiSelect
              id={name}
              data-test="formfield-singleselect-input"
            />
          );
        }
        if (name === "product" && isEdit) {
          return (
            <Input
              value={this._findCurrentProduct(fld, isEdit)}
              disabled
              id={name}
            />
          );
        }
        if (name === "clauses") {
          return (
            <ReactSelect
              isSearchable
              onChange={value => this._changeClauses(fld, value)}
              isDisabled={disabled}
              options={clauses}
              value={this._findCurrentValue()}
              valueKey="name"
              isMulti={multiSelect}
              id={name}
              data-test="formfield-clauses-select"
            />
          );
        }
        return (
          <ReactSelect
            isSearchable
            options={this._generateOptions()}
            value={this._findCurrentValue()}
            onChange={value =>
              // this.props.updateFormRowDataField(fld, value.value)
              this._updateSelectField(fld, value.value)
            }
            isMulti={multiSelect}
            isDisabled={disabled}
            id={name}
            data-test="formfield-update-select"
          />
        );

      default:
        return <p>Field not available</p>;
    }
  };

  render() {
    const fieldClass =
      this.props.span === "full" ? "item-full-span" : "item-half-span";
    if (!this.props.visibility) {
      return null;
    }
    return (
      <div className={`addpbitem-div-wrapper ${fieldClass}`}>
        {this.props.type !== "checkbox" ? (
          <span className="addproduct-label">
            {this.props.label}
            {this.props.required && this.props.applicable ? (
              <span className="required-input">*</span>
            ) : (
              ""
            )}
          </span>
        ) : null}
        {this.props.applicable ? (
          this._generateField(this.props.type)
        ) : (
          <Input
            placeholder="--Not Applicable--"
            value="--Not Applicable--"
            disabled
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    // products,
    props,
    metaData,
    columnDefs,
    customColumnDefs,
    formRowData,
    formDummyFields,
    unusedProducts,
  } = state.PricebookStore;
  // console.debug(formRowData);
  return {
    // products,
    props,
    fieldMapIndex: metaData.fieldMapIndex,
    columnDefs,
    customColumnDefs,
    formRowData,
    formDummyFields,
    unusedProducts,
  };
};

const mapDispatchToProps = {
  updateFormRowData,
  updateFormRowDataField,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FormField);



// WEBPACK FOOTER //
// ./src/components/Pricebook/PricebookItemEditor/FormField.js